import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import Categories from './categories'
import Labels from './labels'
import Access from './access'

const defaultManageDataRoute = '/site-structure'
const defaultRoute = `/manage${defaultManageDataRoute}/events`

const Routes = () => {
  return (
    <Switch>
      <Route
        path={`${defaultRoute}/categories`}
        render={() => <Categories />}
      />
      <Route path={`${defaultRoute}/labels`} render={() => <Labels />} />
      <Route path={`${defaultRoute}/access`} render={() => <Access />} />
      <Redirect from={defaultRoute} to={`${defaultRoute}/categories`} />
    </Switch>
  )
}

export default Routes
